import "react-day-picker/lib/style.css";

import React from "react";
import { LocaleUtils } from "react-day-picker";
import styled from "styled-components";

import { isMonthDisabled } from "src/library/utils";

interface YearMonthSelectProps {
  date: Date;
  localeUtils: LocaleUtils;
  onChange: (yearAndMonth: Date) => void;
  fromMonth?: Date | null;
  toMonth?: Date | null;
}

const YearMonthSelectWrapper = styled.div`
  display: flex;
`;

const YearMonthSelect: React.ReactFCWithChildren<YearMonthSelectProps> = props => {
  const {
    date, localeUtils, fromMonth, toMonth
  } = props;

  const months = localeUtils.getMonths();
  const years: number[] = [];

  if (!fromMonth || !toMonth) {
    return null;
  }

  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
    years.push(i);
  }

  const handleSelect = (type: "year" | "month", data: number) => {
    if (type === "year") {
      props.onChange(new Date(data, props.date.getMonth()));
    } else {
      props.onChange(new Date(props.date.getFullYear(), data));
    }
  };

  return (
    <form className="DayPicker-Caption">
      <YearMonthSelectWrapper>
        <select
          value={date.getMonth()}
          onChange={e => handleSelect("month", parseFloat(e.target.value))}
        >
          {months.map((month, i) => {
            return (
              <option
                key={i}
                value={i}
                disabled={isMonthDisabled(i, fromMonth, toMonth)}
              >
                {month}
              </option>
            );
          })}
        </select>

        {years.length > 1 && (
          <select
            onChange={e => handleSelect("year", years[ parseInt(e.target.value) ])}
            value={years.findIndex(y => y === date.getFullYear())}
          >
            {years.map((year, i) => {
              return (
                <option
                  key={i}
                  value={i}
                >
                  {year.toString()}
                </option>
              );
            })}
          </select>
        )}
      </YearMonthSelectWrapper>
    </form>
  );
};

export default YearMonthSelect;
